import '@ui5/webcomponents-fiori/dist/NotificationListItem.js';
import { Priority } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `NotificationListItem` is a type of list item, meant to display notifications.
 * The component has a rich set of various properties that allows the user to set `avatar`, `titleText`, descriptive `content` and `footnotes` to fully describe a notification.
 * The user can:
 *
 * *   display a `Close` button
 * *   can control whether the `titleText` and `description` should wrap or truncate and display a `ShowMore` button to switch between less and more information
 * *   add custom actions by using the `NotificationAction` component
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/NotificationListItem" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const NotificationListItem = withWebComponent('ui5-li-notification', ['wrappingType', 'busyDelay', 'priority', 'titleText'], ['busy', 'read', 'showClose', 'selected'], ['avatar', 'footnotes', 'actions'], ['close']);
NotificationListItem.displayName = 'NotificationListItem';
NotificationListItem.defaultProps = {
    busyDelay: 1000,
    priority: Priority.None
};
export { NotificationListItem };
